import React from 'react';
import {formatCurrency} from "../../utils/formatCurrency";
import {useInertiaState} from "../../Shared/Layout";
import {useFormState} from "../FormState";
import { Trans } from '../../utils/i18n';
import classNames from "classnames";
import PriceBadge from "./PriceBadge";
import { calculateIncludingTax } from '../../utils/priceCalculations';

export function DeviceWidget({ values, style, product, hidePrice, hideBadge, serviceProduct: serviceProductFromDb, problem1: problem1FromDb, problem2: problem2FromDb, products = [], }) {
    const orderEntryState = useFormState();
    const problem1 = problem1FromDb || orderEntryState?.serialNumber?.problems?.find(item => String(item.id) === values.problem_1);
    const problem2 = problem2FromDb || problem1?.problems?.find(item => String(item.id) === values.problem_2);
    const serviceProduct = serviceProductFromDb || orderEntryState?.serialNumber?.serviceProduct;
    const { countries } = useInertiaState();
    const warranty = !!orderEntryState?.serialNumber?.warranty;

    const country = countries?.find(item => item.id === values?.country_id);

    const productsWithPrices = products
        .map(data => ({
            ...data,
            totalPrice: data?.quantity * data?.product?.price?.priceGross,
            includingTax: calculateIncludingTax({
                amount: data?.quantity,
                tax: data?.product?.price?.vat,
                netPrice: data?.product?.price?.price,
                grossPrice: data?.product?.price?.priceGross,
            }),
        }));
    const contact = values?.private_or_company === 'company' ? values?.name : (values?.first_name || "") + ' ' + (values?.last_name || "");

    const formattedStreet = (() => {
        if(["GB", "US", "IE"].includes(country?.code)) {
            return [(values?.housenumber || '') + ' ' + (values?.street || ''), (values?.city || '') + ', ' + (values?.zip || ''), country?.name]
                .filter(item => item?.trim())
                .join(', ')
        }
        return [(values?.street || '') + ' ' + (values?.housenumber || ''), (values?.city || '') + ', ' + (values?.zip || ''), country?.name]
            .filter(item => item?.trim())
            .join(', ')
    })();

    return (
        <div className={classNames({
            'bg-white flex w-full gap-3 mt-9 items-center flex-wrap rounded-lg p-6': true,
            'b2x-shadow-md': style !== 'alternative',
            'border border-2 border-secondary-900': style === 'alternative',
        })}>
            {
                style !== 'alternative' && (product?.image || orderEntryState?.serialNumber?.product?.image || orderEntryState?.selectedProduct?.image || orderEntryState?.selectedCategory?.image) && (
                    <img className={'h-24 rounded-lg ml-3 mr-9 my-3 hidden md:block'} src={product?.image || orderEntryState?.serialNumber?.product?.image || orderEntryState?.selectedProduct?.image || orderEntryState?.selectedCategory?.image}></img>
                )
            }
            <div className={'md:flex-1 w-full md:w-auto'}>
                {
                    (product || orderEntryState?.serialNumber?.product || orderEntryState?.selectedProduct || orderEntryState?.selectedCategory) && (
                        <p className={'mt-0 mb-1'}><b><Trans i18nKey={'common.device'}>Device</Trans>:</b> <span className={'block md:inline'}>{ product?.description || orderEntryState?.serialNumber?.product?.description || orderEntryState?.selectedProduct?.description || orderEntryState?.selectedCategory?.description }</span></p>
                    )
                }
                {
                    values?.serialnumber && (
                        <p className={'mt-0 mb-1'}><b><Trans i18nKey={'common.serialNumber'}>Serial</Trans>:</b> <span className={'block md:inline'}>{ values?.serialnumber }</span></p>
                    )
                }
                {
                    problem1 && (
                        <p className={'mt-0 mb-1'}><b><Trans i18nKey={'common.issue'}>Issue</Trans>:</b>{ ' '}
                            <span className={'block md:inline'}>{ problem1?.name } - { problem2?.name }</span>
                        </p>
                    )
                }
                {
                    contact && contact !== " " && style !== 'alternative' && (
                        <p className={'mt-0 mb-1'}><b><Trans i18nKey="queueDetail.contact">Contact</Trans>:</b>{ ' '}
                            <span className={'block md:inline'}>{ contact }</span>
                        </p>
                    )
                }
                {
                    style !== 'alternative' && values?.street &&
                    [(values?.street || '') + ' ' + (values?.housenumber || ''), (values?.zip || '') + ' ' + (values?.city || ''), country?.name]
                        .filter(item => item?.trim())
                        .join(', ') && (
                        <p className={'mt-0 mb-1'}><b><Trans i18nKey="queueDetail.address">Address</Trans>:</b>{ ' '}
                            <span className={'block md:inline'}>
                            { formattedStreet }
                            </span>
                        </p>
                    )
                }
                {
                    productsWithPrices.length > 0 && (
                        <>
                            <p className={'mt-0 mb-1'}><b><Trans i18nKey={'common.order'}>Order</Trans>:</b></p>
                            <ul className='mt-0 mb-1 space-y-1'>
                                {
                                    productsWithPrices
                                        .map(data => (
                                            <li className={'mt-0 mb-1'}>
                                                {data?.quantity}x { data?.product?.description }
                                                {" "}({formatCurrency(data?.totalPrice, data?.product?.price?.currency)}{" "}
                                                <Trans i18nKey="orderEntry.product.includedTax" tax={data?.product?.price?.vat/100}>incl. {{ tax: data?.product?.price?.vat/100 }}%</Trans>)
                                            </li>
                                        ))
                                }
                            </ul>
                            <p className={'mt-0 mb-1'}>
                                <b><Trans i18nKey={'partsshop.order.totalPrice'}>Total price</Trans>:</b>{" "}
                                   {formatCurrency(
                                        productsWithPrices.reduce((prev, data) => prev + data?.totalPrice, 0),
                                        productsWithPrices[0]?.product?.price?.currency
                                   )}
                                   {" "}
                                   (<Trans i18nKey="orderEntry.product.includedTax" tax={productsWithPrices?.[0]?.product?.price?.vat/100}>incl. {{ tax: productsWithPrices?.[0]?.product?.price?.vat/100 }}%</Trans>)
                            </p>
                        </>
                    )
                }
            </div>
            {
            !hideBadge &&
                <PriceBadge hidePrice={hidePrice} problem2={problem2} serviceProduct={orderEntryState.serialNumber?.serviceProduct} style={style} warranty={warranty} requesttype={values.requesttype}/>
            }
        </div>
    );
}

export default DeviceWidget
